import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};



// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

// Where a seller installs the Voolist Chrome extension. Poshmark and Depop have no API to connect
// to, so they can only be used with the extension installed.
export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/voolist-%E2%80%93-cross-list-in-o/nakhahocpgjadgcmnlfhohjjegoeockd';

// Shopify is connected by installing the Voolist app from Shopify's own store, which then sends the
// seller back. Against a local API there is no published listing to install, so development points
// at the partner dashboard instead.
export const SHOPIFY_APP_INSTALL_URL = process.env.REACT_APP_HOST_API?.includes('localhost')
  ? 'https://dev.shopify.com/dashboard/130778737/stores'
  : 'https://apps.shopify.com/voolist';
